<script>
 import moment from 'moment'
import Vue from 'vue'
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

 import {
  required,
  minLength,
  maxLength,

} from 'vuelidate/lib/validators' 


/**
 * Inscripción documento
 */
export default {
  components: { Layout, PageHeader,  },
  page: {
    title: 'Validación Documentos',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {     
      title: 'Validación',
      form: {
        idDocumento: '',
        nombre: '',
        nombreArchivo: '',
        tipoDocumento: null,
        organismo: null,
        valoresMetadatos : [],
        informacionReservada: false,
        archivo : null        
      },
  
      requestComboOrganismos :{
        perPage : 100,
        cuerrentPage :0,
        filter: ""
      },
      requestComboTipoDocumentos :{
        perPage : 100,
        cuerrentPage :0,
        filter: ""
      },
      isLoadingCombo : false,
      isLoadingComboTipoDocumentos: false,
      listadoTipoDocumentos: [],
      listadoOrganismos:[],
 
      items: [
        {
          text: 'REPODECAM',
          href: '/',
        },
        {
          text: 'Documentos',
          href: '/documentos/add',
        },
        {
          text: 'Inscripción',
          active: true,
        },
      ],
       submitted: false,
       isBusy: false
    }
  },
  validations: {
    form: {
        nombre: { required,
                  minLength: minLength(4),
                  maxLength: maxLength(255) },
        organismo: { required,
                  },
        tipoDocumento: { required,
                  },
    }

},
  computed:{
  
  },
  mounted(){


         
  },
   methods:{
  
    handleFileUpload(e){        
         this.form.archivo = this.$refs.fileDocumento.files[0];
      },
 
    waitForValidation () {
    return new Promise((resolve) => {
      const unwatch = this.$watch(() => !this.$v.$pending, (isNotPending) => {
        if (isNotPending) {
          unwatch()
          resolve(!this.$v.$invalid)
        }
      }, {immediate: true})
    })},  
   
    handleSubmit(e) {
        this.submitted = true
       
      if(!this.$v.$invalid){

          let formData = new FormData();
          formData.append('nombre',this.form.nombre);
          formData.append('idTipoDocumento',this.form.tipoDocumento.id);
          formData.append('idOrganismo',this.form.organismo.id);
          formData.append('archivo',this.$refs.fileDocumento.files[0]);
          this.form.valoresMetadatos.forEach( function(key, value) {
              
                    formData.append('valores.Index',value);
                    formData.append('valores['+value+'].idMetadato',key.idMetadato);
                    if(key.tipo === "Fecha"){
                         formData.append('valores['+value+'].valor',moment(key.valor).format('DD/MM/YY')); 
                    }else{
                        formData.append('valores['+value+'].valor',key.valor);
                    }
                    
                });

        return axios
            .post(appConfig.recursosApi.documento , formData,
             {
            'Accept': 'application/json',
            'Content-Type': 'multipart/form-data',
          },
           )
            .then((response) => {
              this.$router.push('/documentos/exito') ;
            }).catch(()=>  {
               Vue.swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error al intentar guardar los datos.',
        confirmButtonClass: 'btn btn-confirm mt-2',
        
      })
            });

      }
      this.$v.$touch()
     
    },
}
    
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
 <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Inscripción Documento</h4>
          <p
            class="text-muted font-14 m-b-20"
          >Ingresa la información del documento.</p>

          <form  @submit.prevent="handleSubmit" >

            <div class="form-row">
                <div class="form-group col-md-12">
                    <label for="example-fileinput">Selecciona el Documento</label>
                     <input id="documento"  ref="fileDocumento" type="file"  accept=".pdf"  @change="handleFileUpload"/>
                </div>
            </div>
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">   <b-spinner v-show="isBusy"  small></b-spinner> <i  v-show="!isBusy" class="fas fa-check-circle"></i> Validar</button>
              
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
 </div>
  </Layout>
</template>